var map = {
	"./addManual.svg": "ddb2",
	"./collapse.svg": "37cc",
	"./dataCompass.svg": "f2c5",
	"./delete.svg": "59a1",
	"./dialog_close.svg": "0013",
	"./download.svg": "4dae",
	"./edit.svg": "aa46",
	"./editManual.svg": "872b",
	"./error.svg": "b1b9",
	"./expand.svg": "c963",
	"./export.svg": "077e",
	"./help.svg": "c932",
	"./language.svg": "2580",
	"./lock.svg": "ab00",
	"./logout.svg": "0175",
	"./notice.svg": "fc99",
	"./panel.svg": "9dbc",
	"./payment.svg": "ea4f",
	"./person.svg": "a450",
	"./receipt.svg": "2824",
	"./setting.svg": "05ff",
	"./sidelayer_close.svg": "c6a9",
	"./statistics.svg": "a1cf",
	"./success.svg": "a8cf",
	"./trade.svg": "07d5",
	"./tradeMoney.svg": "7a48"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";